
export const MORNING = 'MORNING'
export const AFTERNOON = 'AFTERNOON'
export const EVENING = 'EVENING'
